import { CheckIcon, MinusIcon } from '@radix-ui/react-icons';
import { AccessibleIcon, Code, Marker, Table } from '@workos-inc/design-system';
export interface AttributeSupport {
  addresses: boolean;
  cost_center: boolean;
  department_name: boolean;
  division_name: boolean;
  emails: boolean;
  employment_start_date: boolean;
  employee_type: boolean;
  job_title: boolean;
  manager_email: boolean;
  username: boolean;
}
export const ATTRIBUTE_SUPPORT: Record<string, AttributeSupport> = {
  'SCIM': {
    addresses: true,
    cost_center: true,
    department_name: true,
    division_name: true,
    emails: true,
    employment_start_date: false,
    employee_type: true,
    job_title: true,
    manager_email: true,
    username: true
  },
  'Google': {
    addresses: true,
    cost_center: true,
    department_name: true,
    division_name: false,
    emails: true,
    employment_start_date: false,
    employee_type: true,
    job_title: true,
    manager_email: true,
    username: true
  },
  'Workday': {
    addresses: true,
    cost_center: true,
    department_name: true,
    division_name: true,
    emails: true,
    employment_start_date: true,
    employee_type: true,
    job_title: true,
    manager_email: true,
    username: true
  },
  'HiBob': {
    addresses: true,
    cost_center: false,
    department_name: true,
    division_name: false,
    emails: true,
    employment_start_date: true,
    employee_type: false,
    job_title: true,
    manager_email: true,
    username: true
  },
  'People HR': {
    addresses: true,
    cost_center: false,
    department_name: true,
    division_name: false,
    emails: true,
    employment_start_date: true,
    employee_type: true,
    job_title: true,
    manager_email: true,
    username: true
  },
  'BambooHR': {
    addresses: true,
    cost_center: false,
    department_name: true,
    division_name: true,
    emails: true,
    employment_start_date: true,
    employee_type: true,
    job_title: true,
    manager_email: true,
    username: true
  },
  'Breathe HR': {
    addresses: true,
    cost_center: false,
    department_name: true,
    division_name: true,
    emails: true,
    employment_start_date: true,
    employee_type: true,
    job_title: true,
    manager_email: true,
    username: true
  },
  'Cezanne HR': {
    addresses: true,
    cost_center: true,
    department_name: true,
    division_name: false,
    emails: true,
    employment_start_date: true,
    employee_type: false,
    job_title: true,
    manager_email: true,
    username: true
  },
  'Fourth': {
    addresses: false,
    cost_center: false,
    department_name: true,
    division_name: false,
    emails: false,
    employment_start_date: true,
    employee_type: true,
    job_title: false,
    manager_email: false,
    username: false
  }
} as const;
export const DirectorySyncAttributeSupportTable = () => <div className="DirectorySyncAttributeSupportTable" data-sentry-component="DirectorySyncAttributeSupportTable" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
    <Table.Root style={{
    whiteSpace: 'nowrap'
  }} data-sentry-element="Table.Root" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
      <Table.Content data-sentry-element="Table.Content" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
        <Table.Header data-sentry-element="Table.Header" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">Attributes</Table.ColumnHeader>
            {Object.keys(ATTRIBUTE_SUPPORT).map((key, i) => <Table.ColumnHeader key={i} justify="center">
                {key}
              </Table.ColumnHeader>)}
          </Table.Row>
        </Table.Header>
        <Table.Body data-sentry-element="Table.Body" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">addresses</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            addresses
          }, i) => <AttributeCell key={i} available={addresses} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">cost_center</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            cost_center
          }, i) => <AttributeCell key={i} available={cost_center} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">department_name</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            department_name
          }, i) => <AttributeCell key={i} available={department_name} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">division_name</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            division_name
          }, i) => <AttributeCell key={i} available={division_name} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">emails</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            emails
          }, i) => <AttributeCell key={i} available={emails} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">employment_start_date</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            employment_start_date
          }, i) => <AttributeCell key={i} available={employment_start_date} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">employee_type</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            employee_type
          }, i) => <AttributeCell key={i} available={employee_type} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">job_title</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            job_title
          }, i) => <AttributeCell key={i} available={job_title} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">manager_email</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            manager_email
          }, i) => <AttributeCell key={i} available={manager_email} />)}
          </Table.Row>
          <Table.Row align="center" data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
            <Table.RowHeader data-sentry-element="Table.RowHeader" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
              <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="directory-sync-attribute-support-table.tsx">username</Code>
            </Table.RowHeader>
            {Object.values(ATTRIBUTE_SUPPORT).map(({
            username
          }, i) => <AttributeCell key={i} available={username} />)}
          </Table.Row>
        </Table.Body>
      </Table.Content>
    </Table.Root>
  </div>;
interface AttributeCellProps {
  available?: boolean;
}
const AttributeCell = ({
  available
}: AttributeCellProps) => {
  if (available) {
    return <Table.Cell justify="center">
        <AccessibleIcon label="Available">
          <Marker color="green">
            <CheckIcon />
          </Marker>
        </AccessibleIcon>
      </Table.Cell>;
  }
  return <Table.Cell justify="center" data-sentry-element="Table.Cell" data-sentry-component="AttributeCell" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
      <AccessibleIcon label="Not available" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-attribute-support-table.tsx">
        <MinusIcon color="var(--gray-9)" height="16" style={{
        margin: 'auto'
      }} width="16" data-sentry-element="MinusIcon" data-sentry-source-file="directory-sync-attribute-support-table.tsx" />
      </AccessibleIcon>
    </Table.Cell>;
};